// Directory snapshots are per Firebase session, never persisted across sign-ins.
export function createDirectoryClient({ auth, endpoint, fetchImpl = (...args) => fetch(...args) }) {
  const snapshots = new Map();
  let owner = null;
  const clone = value => JSON.parse(JSON.stringify(value));
  const request = async payload => {
    const user = auth()?.currentUser;
    if (!user || user.isAnonymous) throw new Error('Verified sign-in required.');
    if (owner !== user) { snapshots.clear(); owner = user; }
    const token = await user.getIdToken();
    if (auth()?.currentUser !== user) throw new Error('Your sign-in has changed.');
    const response = await fetchImpl(endpoint, { method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify(payload), cache: 'no-store' });
    const result = await response.json();
    if (auth()?.currentUser !== user) throw new Error('Your sign-in has changed.');
    if (!response.ok) throw new Error(result.error || 'Directory access failed.');
    return result.value;
  };
  const read = async (tenantId, resource) => {
    const value = await request({ action: 'read', tenantId, resource });
    snapshots.set(`${tenantId}:${resource}`, clone(value));
    return value;
  };
  const write = async (tenantId, resource, value) => {
    if (owner !== auth()?.currentUser) snapshots.clear();
    const key = `${tenantId}:${resource}`;
    const base = snapshots.has(key) ? snapshots.get(key) : await read(tenantId, resource);
    const saved = await request({ action: 'write', tenantId, resource, base, value });
    snapshots.set(key, clone(saved));
    return true;
  };
  // Exact-email lookup across organizations. Returns { id, name, avatar, role, tenantId } or null.
  const find = async email => request({ action: 'find', email: String(email || '').trim().toLowerCase() });
  return { read, write, find };
}
